import type { FetchResponse, RestService, RequestParams, Interceptor } from '@sydle/ui-api';
import { ObjectMethods } from '../object-api';
import type { SelectUserArgs } from './delegation-interceptor-utils';
import { hasDefinedDelegation, hasPendingDelegation, selectUser } from './delegation-interceptor-utils';
import { buildGetParams, extractInfosByURL } from '../utils/url';

export class ObjectDelegationInterceptor implements Interceptor {
  interceptorRequest = async (params: Partial<RequestParams>, isCompletedURL?: boolean): Promise<any> => {
    const requestInfos = extractInfosByURL(params.url, isCompletedURL);
    if (!this.isObjectRequest(requestInfos.methodIdentifier) && !params.additionalParams?.activeDelegationInterceptor)
      return params;

    if (hasDefinedDelegation(params)) return params;
    const _checkDelegation = true;
    if (params.method === 'GET') {
      params.url = buildGetParams(params.url, {
        _checkDelegation,
      });
      return params;
    }

    return {
      ...params,
      method: 'POST',
      body: { ...params.body, _checkDelegation },
    };
  };

  interceptorResponse = async (
    response: FetchResponse,
    requestParams: RequestParams,
    restService: RestService,
  ): Promise<any> => {
    const requestInfos = extractInfosByURL(response.meta.request.url, true);
    if (
      !this.isObjectRequest(requestInfos.methodIdentifier) &&
      !requestParams.additionalParams?.activeDelegationInterceptor
    )
      return response;
    if (!hasPendingDelegation(response)) return response;
    const userOptions: SelectUserArgs[] = response.error.data._userDelegation;
    const delegationUser = await selectUser(userOptions);

    if (!delegationUser) {
      return response;
    }

    requestParams.body._delegationUser = delegationUser.reference;
    requestParams.addBaseUrl = false;

    const result = await restService.fetch(requestParams);
    return result;
  };

  private isObjectRequest(methodIdentifier: string): boolean {
    return methodIdentifier === ObjectMethods.DUPLICATE || methodIdentifier === ObjectMethods.DELETE;
  }
}
